export async function hashPassword(password) {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(password));
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
}

export function apiFetch(url, options = {}) {
  const hash = localStorage.getItem('appPasswordHash') || '';
  const headers = { 'X-App-Password': hash, ...(options.headers || {}) };
  return fetch(url, { ...options, headers });
}

export const GYM_A_NAMES = ['Kniebeuge','Hüftstoß','Rum. Kreuzheben','Ausfallschritte','Wadenheben'];
export const GYM_B_NAMES = ['Latziehen','Seilzugrudern','Bankdrücken (Seilzug)','Schulterdrücken','Gesichtszug','Bizepscurl'];

export function MiniChart({ data, color }) {
  if (!data || data.length === 0) return null;
  const vals = data.map(d => d.gewicht);
  const min = Math.max(0, Math.min(...vals) * 0.92);
  const max = Math.max(...vals);
  const range = max - min || 1;
  const last = data[data.length - 1];
  const prev = data[data.length - 2];
  const trend = prev ? Math.round((last.gewicht - prev.gewicht) * 100) / 100 : 0;

  return (
    <div style={{display:'flex', flexDirection:'column', gap:4}}>
      <div style={{display:'flex', alignItems:'flex-end', gap:2, height:36}}>
        {data.map((d, i) => {
          const isLast = i === data.length - 1;
          const h = Math.max(4, Math.round(((d.gewicht - min) / range) * 28) + 4);
          return (
            <div key={i} style={{display:'flex', flexDirection:'column', alignItems:'center', gap:0, flex:1, maxWidth:28}}>
              <div style={{width:'100%', height:h, borderRadius:'2px 2px 0 0', background: isLast ? color : i === data.length - 2 ? '#2a2a2a' : '#1e1e1e'}}/>
              <div style={{fontSize:8, color: isLast ? color : '#2e2e2e', marginTop:2, whiteSpace:'nowrap'}}>{d.gewicht}</div>
            </div>
          );
        })}
      </div>
      <div style={{display:'flex', justifyContent:'space-between', fontSize:9, color:'#333'}}>
        <span>{data[0].datum.slice(5)}</span>
        <span style={{color: trend > 0 ? color : trend < 0 ? '#8a4a4a' : '#444', fontWeight:700}}>
          {trend > 0 ? `+${trend}` : trend < 0 ? `${trend}` : '='} kg
        </span>
        <span style={{color:'#555'}}>{last.datum.slice(5)}</span>
      </div>
    </div>
  );
}

export function GewichtsHistorie({ verlaufGew, gymAColor = '#4a7c59', gymBColor = '#2a6fa8' }) {
  if (!verlaufGew) return <div style={{color:'#444', fontSize:12, padding:8}}>Lade...</div>;

  const sections = [
    { label:'Unterkörper', namen: GYM_A_NAMES, color: gymAColor },
    { label:'Oberkörper',  namen: GYM_B_NAMES, color: gymBColor },
  ];
  const extra = Object.keys(verlaufGew).filter(n => !GYM_A_NAMES.includes(n) && !GYM_B_NAMES.includes(n));
  if (extra.length) sections.push({ label:'Weitere', namen: extra, color:'#7b4a8a' });

  const heute = new Date();

  return (
    <div style={{background:'#141414', borderRadius:8, overflow:'hidden'}}>
      <div style={{padding:'10px 14px', background:'#1c1c1c', borderBottom:'1px solid #222', fontSize:12, color:'#888'}}>Gewichtshistorie</div>
      {sections.map(sec => {
        const rows = sec.namen.filter(n => verlaufGew[n]?.length > 0);
        if (!rows.length) return null;
        return (
          <div key={sec.label}>
            <div style={{padding:'7px 14px', fontSize:10, color:'#444', letterSpacing:2, textTransform:'uppercase', borderBottom:'1px solid #1a1a1a'}}>{sec.label}</div>
            {rows.map(name => {
              const data = verlaufGew[name];
              const last = data[data.length - 1];
              const tage = Math.floor((heute - new Date(last.datum)) / 86400000);
              return (
                <div key={name} style={{padding:'12px 14px', borderBottom:'1px solid #1a1a1a'}}>
                  <div style={{display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:8}}>
                    <div style={{fontSize:13, color:'#d0d0d0', fontWeight:600}}>{name}</div>
                    <div style={{fontSize:10, color:'#444'}}>{tage === 0 ? 'heute' : tage + 'd'} · {last.gewicht}kg</div>
                  </div>
                  <MiniChart data={data} color={sec.color}/>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
